/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Buy_Now_ButtonInputs */

const en_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy now`)
};

const id_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beli sekarang`)
};

const ms_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beli sekarang`)
};

const ca_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar ara`)
};

const cs_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koupit`)
};

const da_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Køb nu`)
};

const de_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt kaufen`)
};

const et_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osta kohe`)
};

const es_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar ahora`)
};

const fr_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S’abonner`)
};

const hr_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kupite`)
};

const it_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acquista ora`)
};

const lv_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pirkt tagad`)
};

const lt_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pirkti dabar`)
};

const hu_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vásároljon most`)
};

const nl_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu kopen`)
};

const nb_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kjøp nå`)
};

const pl_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kup teraz`)
};

const pt_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprar agora`)
};

const ro_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cumpără acum`)
};

const sk_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kúpiť teraz`)
};

const sl_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kupi zdaj`)
};

const fi_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osta nyt`)
};

const sv_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Köp nu`)
};

const vi_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mua ngay`)
};

const tr_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şimdi satın al`)
};

const el_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αγοράστε τώρα`)
};

const bg_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Купи сега`)
};

const ru_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Купить сейчас`)
};

const sr_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Купите сада`)
};

const uk_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Купити зараз`)
};

const ka_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`იყიდეთ ახლა`)
};

const hi_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी खरीदें`)
};

const th_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ซื้อเลย`)
};

const ko_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지금 구매하기`)
};

const zh_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即购买`)
};

const zh_tw_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即購買`)
};

const ja_buy_now_button = /** @type {(inputs: Buy_Now_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今すぐ購入`)
};

/**
* | output |
* | --- |
* | "Buy now" |
*
* @param {Buy_Now_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const buy_now_button = /** @type {((inputs?: Buy_Now_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Buy_Now_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_buy_now_button(inputs)
	if (locale === "ms") return ms_buy_now_button(inputs)
	if (locale === "ca") return ca_buy_now_button(inputs)
	if (locale === "cs") return cs_buy_now_button(inputs)
	if (locale === "da") return da_buy_now_button(inputs)
	if (locale === "de") return de_buy_now_button(inputs)
	if (locale === "et") return et_buy_now_button(inputs)
	if (locale === "es") return es_buy_now_button(inputs)
	if (locale === "fr") return fr_buy_now_button(inputs)
	if (locale === "hr") return hr_buy_now_button(inputs)
	if (locale === "it") return it_buy_now_button(inputs)
	if (locale === "lv") return lv_buy_now_button(inputs)
	if (locale === "lt") return lt_buy_now_button(inputs)
	if (locale === "hu") return hu_buy_now_button(inputs)
	if (locale === "nl") return nl_buy_now_button(inputs)
	if (locale === "nb") return nb_buy_now_button(inputs)
	if (locale === "pl") return pl_buy_now_button(inputs)
	if (locale === "pt") return pt_buy_now_button(inputs)
	if (locale === "ro") return ro_buy_now_button(inputs)
	if (locale === "sk") return sk_buy_now_button(inputs)
	if (locale === "sl") return sl_buy_now_button(inputs)
	if (locale === "fi") return fi_buy_now_button(inputs)
	if (locale === "sv") return sv_buy_now_button(inputs)
	if (locale === "vi") return vi_buy_now_button(inputs)
	if (locale === "tr") return tr_buy_now_button(inputs)
	if (locale === "el") return el_buy_now_button(inputs)
	if (locale === "bg") return bg_buy_now_button(inputs)
	if (locale === "ru") return ru_buy_now_button(inputs)
	if (locale === "sr") return sr_buy_now_button(inputs)
	if (locale === "uk") return uk_buy_now_button(inputs)
	if (locale === "ka") return ka_buy_now_button(inputs)
	if (locale === "hi") return hi_buy_now_button(inputs)
	if (locale === "th") return th_buy_now_button(inputs)
	if (locale === "ko") return ko_buy_now_button(inputs)
	if (locale === "zh") return zh_buy_now_button(inputs)
	if (locale === "zh-tw") return zh_tw_buy_now_button(inputs)
	if (locale === "ja") return ja_buy_now_button(inputs)
	return en_buy_now_button(inputs)
});